<!--
  Renders the Resource - Generic Page app route
-->
<template>
  <div>
    <!-- Two Column -->
    <template v-if="showRightRail">
      <div class="row c-two-column">
        <div>
          <!-- Placeholder - Top Content -->
          <sc-placeholder name="jss-top-content" :rendering="rendering" />
        </div>
      </div>
      <div class="row c-two-column">
        <!-- Inline styles to position the image in upper right corner -->
        <div
          data-e2e-id="cis-resource-generic-page"
          style="position: relative"
          class="col-lg-12 col-md-12 col-sm-12 template-content"
        >
          <!-- Main Content -->
          <div class="col-lg-9 col-md-9 col-sm-12 template-main-content">
            <resource-heading
              v-bind:title="routeData.fields.resourceTitle"
              v-bind:subTitle="routeData.fields.resourceSubtitle"
              :class="{ 'center-title': centerPageTitle }"
            />

            <!-- Placeholder - Top Left Column Content -->
            <sc-placeholder name="jss-top-left-content" :rendering="rendering" />

            <resource-content v-bind:field="routeData.fields.resourceContent" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" />

            <!-- Placeholder - Bottom Left Column Content -->
            <sc-placeholder name="jss-bottom-left-content" :rendering="rendering" />
          </div>
          <!-- Right Rail -->
          <div
            class="col-lg-3 col-md-3 col-sm-12 template-sidebar"
            :class="{ addShadow: isContent }"
          >
            <!-- Placeholder - Right Rail Top -->
            <sc-placeholder name="jss-right-rail-top" :rendering="rendering" />

            <!-- Right Column Content -->
            <resource-right-column-content v-bind:field="routeData.fields.rightColumnContent" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" />

            <!-- Related Resources -->
            <related-resource v-bind:fields="routeData.fields" />

            <!-- Placeholder - Right Rail -->
            <sc-placeholder name="jss-right-rail" :rendering="rendering" />
          </div>
        </div>
      </div>
    </template>

    <!-- Full Width -->
    <template v-else>
      <div class="row c-full-width">
        <!-- Placeholder - Top Content -->
        <sc-placeholder name="jss-top-content" :rendering="rendering" />

        <div
          data-e2e-id="cis-resource-generic-page"
          style="position: relative"
          class="col-lg-12 col-md-12 col-sm-12 template-content"
        >
          <!-- Main Content -->
          <div class="col-lg-12 col-md-12 col-sm-12 template-main-content">
            <resource-heading
              v-bind:title="routeData.fields.resourceTitle"
              v-bind:subTitle="routeData.fields.resourceSubtitle"
              :class="{ 'center-title': centerPageTitle }"
            />

            <!-- Placeholder - Top Left Column Content -->
            <sc-placeholder name="jss-top-left-content" :rendering="rendering" />

            <resource-content v-bind:field="routeData.fields.resourceContent" />

            <!-- CTA -->
            <cta v-bind:field="routeData.fields.cta" />

            <!-- Placeholder - Bottom Left Column Content -->
            <sc-placeholder name="jss-bottom-left-content" :rendering="rendering" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ResourceHeading from './CIS-ResourceHeading.vue';
import ResourceContent from './CIS-ResourceContent.vue';
import ResourceRightColumnContent from './CIS-ResourceRightColumnContent.vue';
import Cta from './CIS-ResourceCTA.vue';
import RelatedResource from './CIS-ResourceRelatedResources.vue';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-GenericPage',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ResourceHeading,
    ResourceContent,
    ResourceRightColumnContent,
    Cta,
    RelatedResource,
    ScPlaceholder: Placeholder
  },
  data: function () {
    return {
      isContent: false
    };
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    },
    showRightRail() {
      return this.routeData?.fields?.showRightRail?.value;
    },
    centerPageTitle() {
      return this.routeData?.fields?.centerPageTitle?.value;
    }
  },
  mounted() {
    if (window.innerWidth <= 991) {
      if (document.querySelector('.template-sidebar')) {
        var sideBar = document.querySelector('.template-sidebar').innerHTML;
        var newSideBar = sideBar.replace(new RegExp('<!---->', 'g'), '');

        if (newSideBar != '') {
          this.isContent = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.template-sidebar {
  .right-top-cta {
    margin-top: 4rem;
  }

  .right-rail {
    &:deep() {
      .related-resources {
        margin-top: 4rem;
      }
    }
  }
}

// Services Page styles
.resource-content {
  &:deep() {
    .services_row {
      &.row {
        display: flex;
        flex-wrap: wrap;
        margin: 3rem auto;
        @include desktop-up {
          margin: 2rem auto;
        }
        .col-sm {
          &-3 {
            flex: 1 1 1.15rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 1rem;
            width: auto;
            @include desktop-up {
              margin: auto;
            }
            &:nth-child(3) {
              border-left: 1px solid $nav-border;
              @include desktop-up {
                border: none;
                margin: auto;
              }
            }
          }
          &-6 {
            flex: 0 1 100%;
            @include desktop-up {
              flex: 1 1 50%;
            }
          }
          &-3,
          &-6 {
            > a {
              > br {
                display: none;
              }
            }
          }
        }
        .services_table_cell {
          text-align: center;
          img {
            &.mobile-checkmark {
              width: 2.5rem;
            }
          }
        }
      }
    }
  }
}

.center-title {
  &:deep() {
    h1 {
      text-align: center;
    }
  }
}
</style>
